

<template>


  <!-- Loading state for desktop redirect -->
  <div v-if="!isMobile" class="flex justify-center items-center min-h-screen">
    <div class="text-center">
      <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-[#9d2890] mx-auto mb-4"></div>
      <p class="text-gray-300 font-Almarai">جاري التوجيه إلى الصفحة الرئيسية...</p>
    </div>
  </div>
  <!--  -->
  <!-- Continue App Component - Auto show on mobile -->
  <ContinueApp v-if="isMobile && showBottomSheetDirectly && !useSimpleModal" :autoShow="true" />
  
 
</template>

<script>
import ContinueApp from '@/components/ContinueApp.vue'

export default {
  components: {
    ContinueApp
  },
  data() {
    return {
      isMobile: false,
      showBottomSheetDirectly: false,
      useSimpleModal: false
    }
  },
  computed: {},
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    openApp() {
      window.location.href = "https://nasna.onelink.me/KF26/7saihg0d";
    },
    detectDevice() {
      try {
        // Safety checks for window and navigator objects
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
          return false; // Default to desktop if objects are undefined
        }
        
        // Check for mobile devices using user agent and screen width
        const userAgent = navigator.userAgent.toLowerCase();
        const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone', 'mobile'];
        const isMobileUserAgent = mobileKeywords.some(keyword => userAgent.includes(keyword));
        const isSmallScreen = window.innerWidth <= 768;
        
        return isMobileUserAgent || isSmallScreen;
      } catch (error) {
        console.error('Error in detectDevice:', error);
        return false; // Default to desktop on error
      }
    }
  },
  mounted() {
    // Safety check for window object
    if (typeof window === 'undefined') {
      console.error('Window object is undefined');
      this.goToHome();
      return;
    }

    // Detect if device is mobile
    this.isMobile = this.detectDevice();
    
    console.log('SuccessOk mounted:', {
      isMobile: this.isMobile,
      userAgent: navigator.userAgent,
      screenWidth: window.innerWidth
    });

    const origin = localStorage.getItem("origin") || "web";
    
    if (!this.isMobile || origin === "web") {
      // Desktop: redirect to home page after a short delay
      setTimeout(() => {
        this.goToHome();
      }, 1500);
    } else {
      // Mobile: try ContinueApp first, fallback to simple modal
      this.showBottomSheetDirectly = true;
      
      // After 2 seconds, if there are issues, switch to simple modal
      setTimeout(() => {
        if (this.showBottomSheetDirectly) {
          console.log('Switching to simple modal fallback');
          this.useSimpleModal = true;
        }
      }, 2000);
      
      // Final fallback: redirect to home after 8 seconds
      setTimeout(() => {
        if (this.showBottomSheetDirectly) {
          console.log('Final fallback: redirecting to home');
          this.goToHome();
        }
      }, 8000);
    }
  }
};
</script>

<style scoped>
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-basic {
  background-color: #181b30;
}
</style>
